import {
	GET_CURRENT_SEASON,
	GET_CURRENT_SEASON_COMPLETE,
	GET_SEASONS,
	GET_SEASONS_COMPLETE,
	INIT_SEASON_DATA,
	INIT_SEASON_DATA_COMPLETE,
	RESET_CURRENT_SEASON,
	RESTORE_DEFAULT_GAME_CONFIGURATION,
	RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SAVE_DEFAULT_GAME_CONFIGURATION,
	SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE,
	SET_CURRENT_SEASON,
	SET_CURRENT_SEASON_COMPLETE,
	SET_RULE_SET_ID_COMPLETE,
	SET_SEASON_CONFIGURATION,
	SET_SEASON_CONFIGURATION_COMPLETE
} from "./constants";

const initialState = {
	seasons: [],
	currentSeason: null,
	defaultGameConfiguration: {},
	customFormData: {},
	isLoading: false,
	isConfigurationLoading: false,
	selectedSport: []
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case RESTORE_DEFAULT_GAME_CONFIGURATION:
		case SAVE_DEFAULT_GAME_CONFIGURATION:
		case SET_SEASON_CONFIGURATION:
			return {
				...state,
				isConfigurationLoading: true
			};
		case RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE:
		case SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE:
		case SET_SEASON_CONFIGURATION_COMPLETE:
			return {
				...state,
				...payload,
				isConfigurationLoading: false
			};
		case INIT_SEASON_DATA:
		case GET_SEASONS:
		case GET_CURRENT_SEASON:
		case SET_CURRENT_SEASON:
			return {
				...state,
				isLoading: true
			};
		case INIT_SEASON_DATA_COMPLETE:
		case GET_SEASONS_COMPLETE:
		case GET_CURRENT_SEASON_COMPLETE:
		case SET_CURRENT_SEASON_COMPLETE:
		case SET_RULE_SET_ID_COMPLETE:
			return {
				...state,
				...payload,
				isLoading: false
			};
		case RESET_CURRENT_SEASON:
			return {
				...state,
				...payload
			};
		default:
			return state;
	}
};

export default reducer;
